module.exports = __webpack_public_path__ + "media/images/landing/second/photo12-e300c74fa0d5ebc659fb4901584dc7d4.jpg";